export default "__VITE_ASSET__BhU7TQZh__"